import {createTextVariant} from './Text.js'

export default createTextVariant('h6', 'H6')
